import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { GetProcessedOrdersParams, ReceiveApiAdapter } from '../adapters/ReceiveApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const receiveAdapter = new ReceiveApiAdapter(httpClient);

export const useProcessedOrders = (
    receptionId: number,
    params?: GetProcessedOrdersParams,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: ['processed-orders', receptionId, params],
        queryFn: () => receiveAdapter.getProcessedOrders(receptionId, params),
        enabled: enabled && !!receptionId,
    });
};

